import { Component, OnInit, ViewChild } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ArticoloService } from './../../../services/articolo.service';
import { AppComponent } from './../../../app.component';

import { Articolo } from '../../../models/Articolo';
import { Catalogazione } from '../../../models/Catalogazione';

@Component({
  selector: 'app-articolo-form',
  templateUrl: './articolo-form.component.html',
  styleUrls: ['./articolo-form.component.css'],
  providers: [ArticoloService]
})
export class ArticoloFormComponent implements OnInit {
  wmodel: Articolo = new Articolo();
  dirty: boolean;
  loading: boolean;
  eanChecking: boolean;
  updateMode: boolean;
  @ViewChild('f') form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ArticoloService,
    public parent: AppComponent) { }

  persist() {

    this.loading = true;
    this.parent.addToast('', 'salvataggio in corso...', ((wid) => {
      setTimeout(() => {
        this.service.persist(this.wmodel).subscribe((res) => {
          console.log(res)
          if (res.success && res.result) {
            this.wmodel = new Articolo(res.result.value);
          }
          this.parent.clearToast(wid);
          this.loading = false;
          this.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
          this.updateMode = res.success;
        })
      }, 2000);
    }))
  }

  onNotifyArticolo(o: Articolo): void {
    console.log('onNotify', o)
  }

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id');
    console.log(id);
    if (id) {
      this.updateMode = true;
      this.service.getArticolo(id).subscribe(result => {
        console.log(result);
        this.wmodel = new Articolo(result.articolo);
        console.log(this.wmodel);
        this.updateMode = true;
      })
    } else {
      this.wmodel = new Articolo();
      this.wmodel.anno = +((new Date()).getFullYear());
      this.wmodel.testata = {
        codice: '05',
        descrizione: 'Testimoni'
      }
      this.updateMode = false;
    }
  }

  ctrlEanRivista(e) {
    console.log('ctrlEanRivista')
    if (this.wmodel.anno && this.wmodel.numero) {
      this.eanChecking = true;
      setTimeout(() => {
        this.service.getEan13(this.wmodel.anno, this.wmodel.numero).subscribe((res) => {
          console.log(res);
          if (res.success && res.pe) {
            this.wmodel.ean13rivista = res.pe.EAN;
          }
          this.eanChecking = false;
        })
      }, 1000);
    }
  }

  add() {
    this.router.navigate(['/articolo']);
  }

  go2search() {
    this.router.navigate(['/articolo/search']);
  }


  // ===== Catalogazione ======
  addCatalogazione() {
    this.wmodel.catalogazione.push(new Catalogazione());
  }

  removeCatalogazione(i) {
    console.log('removeCatalogazione index', i)
    this.wmodel.catalogazione.splice(i, 1);
  }

  trackCatalogazione(index: number, value: Catalogazione) {
    return index;
  }

  // ===== Indice geografico ======
  addIndiceGeografico() {
    this.wmodel.indiceGeo.push(new Catalogazione());
  }

  removeIndiceGeografico(i) {
    console.log('removeIndiceGeografico index', i)
    this.wmodel.indiceGeo.splice(i, 1);
  }

  trackIndiceGeografico(index: number, value: Catalogazione) {
    return index;
  }

  getTitle(): string {
    return "articoli";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/articolo/articolo-form/articolo-form.component.ts